import React,{useState, useEffect} from 'react';
import ReactLoading from 'react-loading';
import {DivMain,SpanLoader} from './StyledLoading';
function Loading() {
  return<DivMain >
        <SpanLoader>Carregando</SpanLoader>
        <ReactLoading type={"spokes"} color={"#fff"} height={150} width={150} />
    </DivMain>
}

export default Loading;
